import { filterObjectFromWhiteList } from 'services/Formats';

/** Copyright (c) 2019 T. Rowe Price. All rights reserved. */

export const PRIMARY_CONTACT = 100;
export const RESIDENTIAL_ADDRESS_CONTACT = 103;

export const DAYTIME = 102;
export const EVENING = 103;
export const FAX = 101;
export const MOBILE = 100;

export const STOP_MAIL = 100;
export const ANNUAL_VERIFICATION = 101;
export const EMAIL_NOT_DELIVERABLE = 102;
export const NO_EMAIL = 103;

export const CMMPhoneNumberOrder = [DAYTIME, EVENING, MOBILE];

export const CMMPhoneMapper = {
  [MOBILE]: 'Mobile',
  [DAYTIME]: 'Daytime',
  [EVENING]: 'Evening'
};

export const VERIFICATION_INVALID_MAILING_ADDRESSES = [
  STOP_MAIL,
  ANNUAL_VERIFICATION
];

export const VERIFICATION_INVALID_EMAIL_ADDRESSES = [
  EMAIL_NOT_DELIVERABLE,
  ANNUAL_VERIFICATION
];

export const INVALID_EMAIL_ADDRESSES_ONLY = [EMAIL_NOT_DELIVERABLE];

export const NO_EMAIL_ADDRESSES_ONLY = [NO_EMAIL];

export const INVALID_MAILING_ADDRESSES_ONLY = [STOP_MAIL];

export const VERIFICATION_NO_EMAIL_ADDRESSES = [NO_EMAIL, ANNUAL_VERIFICATION];

export const INVALID_MAILING_AND_EMAIL_ADDRESSES = [
  STOP_MAIL,
  EMAIL_NOT_DELIVERABLE
];

export const INVALID_MAILING_AND_NO_EMAIL_ADDRESSES = [STOP_MAIL, NO_EMAIL];

export const VERIFICATION_INVALID_MAILING_AND_EMAIL_ADDRESSES = [
  STOP_MAIL,
  ANNUAL_VERIFICATION,
  EMAIL_NOT_DELIVERABLE
];

export const VERIFICATION_INVALID_MAILING_AND_NO_EMAIL_ADDRESSES = [
  STOP_MAIL,
  ANNUAL_VERIFICATION,
  NO_EMAIL
];

export const ANNUAL_VERIFICATION_TITLE =
  'Annual Contact Information Verification';
export const EMAIL_ADDRESSES_TITLE = 'Email Address Update';
export const MAILING_ADDRESSES_TITLE = 'Mailing Address Update';
export const CONTACT_INFORMATION_UPDATE_TITLE = 'Contact Information Update';

const invalidMailingErrorKeys = [
  'hasVerificationInvalidMailing',
  'hasVerificationInvalidMailingAndEmail',
  'hasVerificationInvalidMailingAndNoEmail'
];

//If any of the mailing verification errors are true, show the stop mail disclaimers
export const annualVerificationHasInvalidMailing = (errors) => {
  const filteredErrors = filterObjectFromWhiteList(errors, invalidMailingErrorKeys);
  return Object.keys(filteredErrors).some(key => filteredErrors[key]);
};